<template>
  <div>
    <div class="topic">
      <div class="pic"><img src="/static/img/sk/story.jpg" width="100%" alt="鲨湾科技专注打造智能电动出行产品"></div>
      <div class="company">
        <div class="fs_big">Sharkgulf Technology</div>
        <div class="companycontent">샤크 걸프 테크놀로지는 전기자동차 기술을 기반으로<br/>지금까지 찾아 볼 수 없었던<br/>새로운 바이크를 탄생시킨 하이테크솔루션 컴퍼니 입니다.</div>
      </div>
      <!-- <div class="tobottom"><img src="/static/img/tobottom.png" width="100%" alt=""></div> -->
    </div>
    <div class="content">
      <div class="content_top">샤크걸프 테크놀로지는 글로벌 전기차 기업인 싱글라토 모터스의 CEO인 쉔 하인(Shen Haiyin)과 중국 최대 보안솔루션 업체 티아이-링크의 CEO 인 리우 후린(Liu Hulin)이 2018년 8월 공동 설립한 스마트 전기 모빌리티 회사로 미국 실리콘 밸리, 홍콩 및 상하이에 베이스를 두고 있습니다<br/><br/>전기자동차 기술과 디자인, 전문 레이싱 바이크 수준의 품질로 혁신을 이루며, 숨 쉬는 듯 자연 스럽고 쾌적한 라이딩을 소비자에게 선사하기 위해 수 년간 기술개발을 진행해온 샤크걸프 테크놀로지는 자동차 수준의 듀얼 ECU+CAN버스 지능형 중앙 제어 시스템, 73개의 감지센서, ADAS, 지문시동, 이중유압 디스크 등 뛰어난 성능을 기반으로 ‘블루샤크’를 론칭 했습니다 <br/><br/>블루샤크 코리아는 기존 전기 스쿠터에서 경험 할 수 없었던 혁신으로 무장한 스마트 전기바이크를 한국에 선보이며 차원이다른 스마트 모빌리티를 선사하겠습니다.</div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {

    }
  },
  mounted(){
    let that = this
    window.scrollTo(0,0)
    this.$nextTick(function(){
      window.addEventListener("scroll", that.animateTxt);
    })
  },
  beforeDestroy(){
    window.removeEventListener("scroll", this.animateTxt);
  },
  methods: {
    animateTxt(){
      let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
      if(top <= 100){
        this.$emit("hidenav");
      } else {
        this.$emit("shownav");
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/common.less';
.topic{
  position: relative;
  .pic{
    font-size: 0;
  }
  .company{
    position: absolute;
    text-align: center;
    width: 100%;
    color: #fff;
    top: 15vw;
    .companycontent{
      font-size: 14px;
      margin-top: 30px;
      line-height: 30px;
    }
  }
  .tobottom{
    position: absolute;
    width: 20px;
    margin: 0 auto;
    left: 0;
    right: 0;
    bottom: 3vw;
  }
}
.content{
  padding: 5vw 0;
  .content_top{
    width: 42%;
    margin: 0 auto;
    color: #666;
    line-height: 30px;
    padding-bottom: 2vw;
    // border-bottom: 1px solid #ddd;
  }
  .content_bottom{
    width: 42%;
    margin: 0 auto;
    .subtitle{
      margin-top: 50px;
      margin-bottom: 5px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/sk/story.vue